import "./activateDeactivateModal.css"
import {DiscoverPlayersTable} from "features/discover/DiscoverPlayersTable";
import { Dispatch, SetStateAction, useState } from "react";
import {
	DiscoverPlayersRowResponse,
	DiscoverUserPermissionPostRequest,
} from "libs/apiClient";
import {useToast} from "ui-kit";
import client from "libs/client";

export function PlayerSelectGridModal({
	setShowAddPermissionModal,
    setPermissionModalSize,
	userId,
}: {
	setShowAddPermissionModal: Dispatch<SetStateAction<boolean>>;
	setPermissionModalSize: Dispatch<SetStateAction<"full" | "sm">>;
	userId: number;
}) {
	const { addErrorToast, addSuccessToast } = useToast();
	const [selectedPlayer, setSelectedPlayer] = useState<DiscoverPlayersRowResponse | null>(null);

	const postUserPermissionMutation = client.postDiscoverUserPermission.useMutation({
		onSuccess: () => {
			addSuccessToast("Permission created");
			client.queryClient.invalidateQueries({
				predicate: (query) => query.queryKey.includes("discoverUserDetail"),
			});
			setShowAddPermissionModal(false);
			close();
		},
		onError: (res) => {
			if (res.status !== 403) {
				addErrorToast(res.message);
			}
		},
	});

	const handleSubmit = () => {
		postUserPermissionMutation.mutate({
			body: {
				entityType: "player",
				entityId: selectedPlayer?.id,
				userId: userId,
				role: "player",
				policyName: "admin",
			} as DiscoverUserPermissionPostRequest
		})
	}

	const handleSetPlayer = (row: DiscoverPlayersRowResponse) => {
		console.log(row)
		if (!row.isDummy) {
			addErrorToast('Only dummy player can be assigned');
			return;
		}
		setSelectedPlayer(row);
		setPermissionModalSize("sm");
	}

	const handleClearPlayer = () => {
		setSelectedPlayer(null);
		setPermissionModalSize("full");
	}

	const isFormValid = selectedPlayer?.isDummy === true;

    return (
		<div className="user-permission-dialog">
			{selectedPlayer ? <>
				<dl className="admin-definition-list">
					<dt>ID:</dt> <dd>{selectedPlayer.id}</dd>
					<dt>Name:</dt> <dd>{selectedPlayer.name}</dd>
					<dt>Club:</dt> <dd>{selectedPlayer.club?.name || '-'}</dd>
					<dt>Team:</dt> <dd>{selectedPlayer.team?.name || '-'}</dd>
				</dl>
				<div className="admin-buttons admin-buttons--right">
					<button className="admin-button admin-button--secondary" onClick={handleClearPlayer}>Choose different player</button>
					<button className="admin-button admin-button--primary" disabled={!isFormValid} onClick={handleSubmit}>Create permission</button>
				</div>
			</> : <>
				<DiscoverPlayersTable
					rowAction={handleSetPlayer}
				/>
			</>}
		</div>
    )
}
